import { render, staticRenderFns } from "./SendEmailView.vue?vue&type=template&id=0fd437d1&scoped=true"
import script from "./SendEmailView.vue?vue&type=script&lang=js"
export * from "./SendEmailView.vue?vue&type=script&lang=js"
import style0 from "./SendEmailView.vue?vue&type=style&index=0&id=0fd437d1&prod&lang=scss&scoped=true"
import style1 from "./SendEmailView.vue?vue&type=style&index=1&id=0fd437d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd437d1",
  null
  
)

export default component.exports